import React, { useEffect, useState } from 'react';
import LeadHistoryModal from './common/LeadHistoryModal';
import Select from 'react-select';
import { MANAGER_LEVEL_IDS } from '../../src/config/constant';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../src/common/Pagination';
import secureStorage from '../../src/config/encrypt';
import * as HELPER from "../../src/config/helper";
import { updateLeadAssignUser } from '../../src/store/slices/insurance';
import { useLanguage } from '../../src/context/LanguageContext';
import { ROLE_FEATURES } from "../config/ph/constant"; 
import moment from "moment";
import DynamicTable from '../component/table/DynamicTable';
import { tables } from '../config/switch';

interface SelectedLead {
  lead_id: number;
}


const LeadListTable = (props: any) => {
  const [viewTimeLine, setViewTimeLine] = useState(false);
  const {insuranceList, paginationData, selectedFilters, getInsuranceListing, assignUsers,setSortVal} = props;
  const page = 1;
  const [showSelectedAssignSave, setShowSelectedAssignSave] = useState(0);
  const [leadListData, setLeadListData] = useState<any>([]);
  const [selectedRemarkLead, setSelectedRemarkLead] = useState<any>(0);
  const [sortDirection, setSortDirection] = useState<any>({ due_date: '', followup: '',balance_left:'' });

  const {translations} = useLanguage();
  
  useEffect(() => {
    setLeadListData(insuranceList);
  }, [insuranceList])

  const handleViewTimeLine = (type: boolean, leadId: number) => {    
      setViewTimeLine(type);
      setSelectedRemarkLead(leadId);
  }
  const authUserInfo = secureStorage.getItem("authUserInfo");
  const navigate = useNavigate();

  const detailPageRedirect = (id:number) => {
        navigate(`/lead-details/${id}`);
  }

  const getSelectedAssignUser = (id: any) => {      
      let getSelectedUser = assignUsers.find((u: any) => +u.value === +id);
      return getSelectedUser || null;
  }

  const handleRequestData = (params: any) => {
        let apiParams = {
      ...selectedFilters,
      ...params,
      page_number: params.page_no
    }

    getInsuranceListing(apiParams)

  }

  const handleChangeAssign = (leadId: any, e: any) => {
        setLeadListData(insuranceList.map((u: any) => { return (u.leadId === leadId) ? { ...u, 'assigned_user_id': e.value } : u }));
        setShowSelectedAssignSave(leadId);
  }

  const saveAssignLeadHandler = (params: { id: string, action: string }) => {
        if (params.action === "cancel") {
            setShowSelectedAssignSave(0);
            setLeadListData([...insuranceList])
        } else {
            let getLead: any = leadListData.find((ins: any) => ins.id === params.id) || {};
            updateLeadAssignUser({ lead_id: params.id, "assigned_user_id": getLead['assigned_user_id'] }).then((res: any) => {
                if(res && res.status === 200) {
                  handleRequestData({page_no: 1});                              
                  setShowSelectedAssignSave(0)
                }
            }).catch(err => {

            })
        }
  }

  const getDueDateClass = (lead: any): string => {
    const today = new Date();
    const dueDate = new Date(lead?.next_due_date);

    if (!lead?.next_due_date) return ""; // no date, no class

    if (today > dueDate) {
      return "txt-highlight";
    }

    const daysUntilDue =
      (dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);

    if (daysUntilDue <= 14) {
      // Upcoming within 14 days: yellow
      return "txt-yellow";
    }

    // Default: no class
    return "";
  };


  const handleSort = (column: string) => {

    const currentDirection = sortDirection[column];
    const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';

    setSortDirection((prev: any) => ({
      ...prev,
      [column]: newDirection || 'desc'
    }));

    const sortParam = `${column}_${newDirection || 'desc'}`;
    setSortVal(sortParam);
    const apiParams = {
      sort: sortParam,
      page_number: 1
    };

    getInsuranceListing(apiParams);
  };

  const handleSelectAll = (isChecked: boolean) => {
        if (isChecked) {
            // select all
          const allSelected: SelectedLead[] = leadListData.map((lead: any) => ({
            lead_id: lead.leadId,
          }));
          props.setSelectedLeads(allSelected);
      } else {
          // unselect all
          props.setSelectedLeads([]);
      }
  };

  // Handle individual checkbox change
  const handleItemSelect = (lead: { lead_id: number },isChecked: boolean): void => {
      if (isChecked) {
          props.setSelectedLeads((prev:any) => [
              ...prev,
              {
                  lead_id: lead.lead_id,
              },
          ]);
      } else {
          props.setSelectedLeads((prev:any) =>
              prev.filter(
                  (item:any) => !(item.lead_id === lead.lead_id)
              )
          );
      }
  }
 
  const IS_COLLECTION_AGENT = (secureStorage.getItem("authUserInfo")?.user_data?.assigned_role_ids === 4) ? true : false; 
  const IS_MANAGER = MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids);
  const isAllSelected = leadListData.length > 0 && props.selectedLeads.length === leadListData.length;
  props.setIsAllLeadsSelected(isAllSelected)
  return (
    <>
    <div className="data-table lead-list-table dashboard-list-table">
      <DynamicTable
        columns={tables.getLeadTable(translations)}
        data={leadListData}
        translations={translations}
        isAllSelected={isAllSelected}
        handleSelectAll={handleSelectAll}
        conditions={{
          isCollectionAgent: IS_COLLECTION_AGENT,
          isManager: IS_MANAGER,
          canAssignLead: IS_MANAGER || IS_COLLECTION_AGENT
        }}
        sortDirection={sortDirection}
        onSort={handleSort}
        roleFeatures={ROLE_FEATURES}
        helper={{
          ...HELPER,
          assignUsers,
          getSelectedAssignUser,
          handleChangeAssign,
          showSelectedAssignSave,
          saveAssignLeadHandler,
          viewDetails: (row: any) => detailPageRedirect(row.hashId),
          viewTimeline: (row: any) => handleViewTimeLine(true, row.leadId),
          isItemSelected: (row: any) =>
          props.selectedLeads.some(
              (item: any) =>
              item.lead_id === row.leadId &&
              item.remittance_type_id === row.remittance_type_id
          ),
          handleItemSelect,
        }}
      />
      {/* <table>
        <thead>
          <tr>
            <th>Policy No.</th>
            <th>Customer Details</th>
            <th>Created By</th>
            <th>Premium</th>
            <th>
              Balance Due
              <i
                 className={`ic-sort-${
                  sortDirection.balance_left === ''
                    ? 'desc'
                    : sortDirection.balance_left
                }`}

                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('balance_left')}
              ></i>
            </th>
            <th>Insurer</th>
            <th>EMI Amount /<br/>Premium Amount</th>
            <th>Payment Received</th>
           
            <th>
              Due Date
              <i
                 className={`ic-sort-${
                  sortDirection.due_date === ''
                    ? 'desc'
                    : sortDirection.due_date
                }`}

                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('due_date')}
              ></i>
              </th>
              {
                !IS_COLLECTION_AGENT &&  <th>Credit Term <br />Ends on</th>
              } 
              <th>

                Disposition /<br />Follow-up Date
                <i
                  className={`ic-sort-${
                    sortDirection.followup === ''
                      ? 'desc'
                      : sortDirection.followup
                  }`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('followup')}
                ></i>
              </th>
              <th>Source Type</th>
              <th>Status</th>
              {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && <th className='assigned-to-col'>Assigned to</th>}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {(leadListData && leadListData.length) ? leadListData.map((lead: any, index: any) => (
              <tr key={index}>
                <td>
                  <span title={lead?.policy_no} className='truncate'>{lead?.policy_no || ""}</span>
                  <span>INS{lead?.leadId}</span>
                </td>
                <td>
                  <span title={lead?.customer_name} className='truncate text-bold'>{lead?.customer_name || ""}</span>
                  <span title={lead?.customer_mobile} className='truncate'>{lead?.customer_mobile || ""}</span>
                </td>
                <td>
                  <span title={lead?.created_by_name} className='truncate'>{lead?.created_by_name || ""}</span>
                  <span><b className='text-bold'>ID:</b> {lead?.created_by_id || ""}</span>
                </td>
                <td>
                   <span>{`${HELPER.addCurrencyFormatting(lead?.total_premium)}`}</span>
                </td>
                <td>
                  <span>{`${HELPER.addCurrencyFormatting(lead?.balance_left)}`}</span>
                 </td>
                <td>{lead?.insurer_name || ""}</td>
                <td>
                  <span>
                    {(lead?.isInstallment)
                      ? `${HELPER.addCurrencyFormatting(lead?.emi_amount)}`
                      : `${HELPER.addCurrencyFormatting(lead?.total_premium)}`}
                  </span>

                  {lead?.isInstallment ? (
                    <span>
                      {lead?.total_emi_paid}/{lead?.total_emi_count} EMI
                    </span>
                  ) : ""}
                </td>
                <td>
                  <span>{`${HELPER.addCurrencyFormatting(lead?.received_amount)}`}</span>
                  {lead?.balance_left > 0 && (lead?.received_amount / lead?.total_premium) * 100 < 99 && (
                    <span className="overdue-day-bg">Balance {`${HELPER.addCurrencyFormatting(lead?.balance_left)}`}</span>
                  )}
                </td>
                <td>
                  <span className={getDueDateClass(lead)}>{lead?.next_due_date ? moment(lead.next_due_date).format("DD MMM, YYYY") : ""}</span>
                  {lead?.overdue_day_count >= 1 && (
                    <span className="overdue-day-bg">{lead?.overdue_day_count || ""} days overdue</span>
                  )}
                </td>
                {
                  !IS_COLLECTION_AGENT && <td>
                  <span className={(lead?.credit_term_ends && lead?.credit_term_ends < 14) ? 'txt-highlight' : ''}>{(lead?.credit_term_ends) ? `${lead?.credit_term_ends} Days ` : ""}</span>
                  </td>
                } 
                <td>
                  {
                    lead?.followup_date ?
                      <>
                        <span>{lead?.followup_status_name || ""}</span>
                        <span>{moment(lead.followup_date).format("DD MMM, YYYY hh:mm A") || ""}</span>
                      </>
                      : <span> - </span>
                  }

                </td>
                <td className='resizeLine truncate' title={lead?.source_type} >{lead?.source_type}</td>
                <td>
                  <span>{lead?.status_name}</span>
                </td>
                {
                  (MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids)) &&
                  <td>
                    <div className="select-table">
                      <fieldset className="single-select assigned-to-select">
                        <div className="material table-select-box__placeholder" title={getSelectedAssignUser(lead.assigned_user_id)?.label || ""}>
                            <Select
                              value={getSelectedAssignUser(lead.assigned_user_id)}
                              onChange={(e) => handleChangeAssign(lead.leadId, e)}
                              options={assignUsers}
                              placeholder="Assign To"
                              isDisabled={lead?.status === 8}
                              styles={{
                                option: (provided) => ({
                                  ...provided,
                                  whiteSpace: 'normal',
                                  wordWrap: 'break-word',
                                  wordBreak: 'break-word'
                                })
                              }}
                            />
                          {HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['Leads'], accessType: 'edit' }) && (showSelectedAssignSave === lead.leadId) && lead.status_name !== "Reco Done" && <div className="amt-edit-opt"><button className="btn-primary" onClick={() => saveAssignLeadHandler({ id: lead.id, action: 'save' })}>Save</button><i className="ic-clearclose" onClick={() => saveAssignLeadHandler({ id: lead.id, action: 'cancel' })}></i></div>}
                        </div>
                      </fieldset>
                    </div>
                  </td>
                }
                <td>
                  <ul className="action-btn">
                    <li onClick={() => detailPageRedirect(lead.hashId)}>
                      <i className="ic-remove_red_eyevisibility"></i>
                    </li>
                    <li onClick={() => { handleViewTimeLine(true, lead.leadId) }}>
                      <i className="ic-Call-history"></i>
                    </li>
                  </ul>
                </td>
              </tr>
            )) : <tr><td colSpan={14} style={{ textAlign: 'center' }}>{translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}</td></tr>
            }
          </tbody>
      </table> */}

        {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
          page,
          loading: false,
          totalLengthWithoutPagination: paginationData['total'],
          paginationData,
          filteredData: selectedFilters
        }}
          sendRequestDataToParent={handleRequestData} />}
      </div>
      {viewTimeLine && <LeadHistoryModal selectedRemarkLead={selectedRemarkLead} viewTimeLine={viewTimeLine} handleViewTimeLine={handleViewTimeLine} />}
    </>
  );
};

export default LeadListTable;
